/**
 * Converting to the right format that we have been using.
 * For example:
 *  encoded smtp: aaaabbbbccccddddeeeeffffgggghhhh%40domain.com
 *  guid = 'aaaabbbb-bbbb-bbbbcccc-bbbbccccdddd-ffffgggghhhh'
 */
export default function getBookingMailboxGuid(bookingMailbox: string): string {
    return addDashes(bookingMailbox);
}

function addDashes(uuid: string) {
    if (uuid == '') {
        return '';
    }
    return (
        uuid.substring(0, 8) +
        '-' +
        uuid.substring(8, 4) +
        '-' +
        uuid.substring(12, 4) +
        '-' +
        uuid.substring(16, 4) +
        '-' +
        uuid.substring(20)
    );
}
